// Filters converted to regular functions for Vue 3 compatibility
export const filters = {
  currency(value) {
    value = parseFloat(value);
    value = isNaN(value) ? 0 : value;
    value = value.toFixed(2);
    value = value.replace(/\.00$/, ''); // if it's an integer, remove cents
    return  value + ' €';
  },

  toDate(value) {
    if (value instanceof Date) {
      return value
    }
    if (!value) {
      return null
    }
    return new Date(value.replace(/\s/, 'T'))
  },

  dateFormat(value) {
    if(!value){
      return '';
    }
    let year = value.getFullYear() + '';
    let month = (value.getMonth()+1) + '';
    month = (month.length === 2) ? month : '0'+month;
    let day = value.getDate() + '';
    day = (day.length === 2) ? day : '0'+day;
    return day + '/' + month + '/' + year;
  },

  dateTimeFormat(date) {
    const dateFormatter = new Intl.DateTimeFormat([], { year: 'numeric', month: '2-digit', day: '2-digit' })
    const timeFormatter = new Intl.DateTimeFormat(['it'], { hour: '2-digit', minute: '2-digit' })
    if (!date) {
      return ''
    }
    return dateFormatter.format(date) + ' - ' + timeFormatter.format(date)
  },

  striphtml(value) {
    var div = document.createElement("div");
    div.innerHTML = value;
    var text = div.textContent || div.innerText || "";
    return text;
  },

  date(value) {
    return this.dateFormat(this.toDate(value));
  }
};

// Helper function to chain filters (like | toDate | dateFormat)
export function chainFilters(value, ...filterNames) {
  return filterNames.reduce((acc, filterName) => {
    return filters[filterName](acc);
  }, value);
}
